/* global $:false */

import 'modernizr.js'
import Drift from 'drift-zoom/src/js/Drift.js'
import 'spritespin.js'

export default class LotGalleryImage {
  static init () {
    $('.js-push-lot-screen').on('htmlPush:afterReplace',  event => {
      if (!event.target.classList.contains('js-push-lot-screen')) { return }
      LotGalleryImage.setup()
    })

    this.setup()
  }

  static setup () {
    Array.from($('.js-lot-carousel-image')).map(el => new LotGalleryImage(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.start()
  }

  findElements () {
    this.zoomContainer = $('.js-lot-zoom-container')
  }

  readDataAttributes () {
    this.threesixtyUrlPattern = this.el.data('threesixty-url-pattern')
  }

  start () {
    if (this.threesixtyUrlPattern) {
      this.replaceWithThreesixty()
    } else {
      this.setupHoverPreview()
    }
  }

  setupHoverPreview () {
    if (window.Modernizr.touchevents) { return }
    return new Drift(
      this.el[0], {
        namespace: 'c-live-lot-show-lot__drift',
        zoomFactor: 8,
        paneContainer: this.zoomContainer[0],
        inlinePane: false,
        injectBaseStyles: false
      }
    )
  }

  replaceWithThreesixty () {
    const template = $('<div class="c-lot-carousel__link c-lot-carousel__link--threesixty">')
    template.insertBefore(this.el.parent())
    this.el.parent().remove()

    template.spritespin({
      source: this.threesixtyImages(),
      frameTime: 65,
      width: 512,
      height: 512,
      responsive: true,
      sense: -1,
      behavior: 'drag-animate-on-release'
    })
  }

  threesixtyImages () {
    return window.SpriteSpin.sourceArray(
      this.threesixtyUrlPattern, {
        frame: [1, 80],
        digits: 2
      }
    )
  }
}

function dragEnd (e, data) {
  if (data.dragging) {
    data.dragging = false
    data.animate = true

    window.SpriteSpin.setAnimation(data)
  }
}

window.SpriteSpin.registerModule('drag-animate-on-release', {
  mousedown: window.SpriteSpin.mods.drag.mousedown,
  mousemove: window.SpriteSpin.mods.drag.mousemove,
  mouseup: dragEnd,
  documentmousemove: window.SpriteSpin.mods.drag.documentmousemove,
  documentmouseup: dragEnd,
  touchstart: window.SpriteSpin.mods.drag.touchstart,
  touchmove: window.SpriteSpin.mods.drag.touchmove,
  touchend: dragEnd,
  touchcancel: dragEnd
})
